export interface UserGroup {
  id: number;
  name: string;
}

export function UserGroupFromJSON(json: any): UserGroup {
  return {
    id: json["id"],
    name: json["name"],
  };
}
